import type { BannerSwapStatus } from "../../utils/@types";

export type BannerSwapStatusStyle = {
  label: string;
  backgroundColor: string;
  textColor: string;
  borderColor: string;
};

const STATUS_STYLES: Record<BannerSwapStatus, BannerSwapStatusStyle> = {
  failed: {
    label: "Failed",
    backgroundColor: "#fecaca",
    textColor: "#991b1b",
    borderColor: "#f87171",
  },
  partial_failed: {
    label: "Partial failed",
    backgroundColor: "#fde68a",
    textColor: "#92400e",
    borderColor: "#fbbf24",
  },
  scheduled: {
    label: "Scheduled",
    backgroundColor: "#fed7aa",
    textColor: "#9a3412",
    borderColor: "#fb923c",
  },
  running: {
    label: "Running (Live)",
    backgroundColor: "#bfdbfe",
    textColor: "#1e40af",
    borderColor: "#60a5fa",
  },
  completed: {
    label: "Completed",
    backgroundColor: "#bbf7d0",
    textColor: "#166534",
    borderColor: "#4ade80",
  },
  cancelled: {
    label: "Cancelled",
    backgroundColor: "#e5e7eb",
    textColor: "#374151",
    borderColor: "#9ca3af",
  },
};

export function getBannerSwapStatusStyle(
  status: BannerSwapStatus
): BannerSwapStatusStyle {
  return (
    STATUS_STYLES[status] ?? {
      label: status,
      backgroundColor: "#e5e7eb",
      textColor: "#374151",
      borderColor: "#9ca3af",
    }
  );
}

export const ALL_BANNER_SWAP_STATUSES: BannerSwapStatus[] = [
  "scheduled",
  "running",
  "completed",
  "partial_failed",
  "failed",
  "cancelled",
];
